import {RouteConfig} from 'common/src/modules/routing/routing.types';
import {DateTime} from 'luxon';

enum BGProcessStatus {
  Success = 'success',
  Failed = 'failed',
  Warn = 'warn',
  InProgress = 'in-progress',
}

enum BGProcessLinkType {
  Download,
  Href,
}

type BGProcessLink =
  | {type: BGProcessLinkType.Download; label: string; value: string; fileName?: string}
  | {type: BGProcessLinkType.Href; label: string; value: RouteConfig};

interface BGProcess {
  id: string;
  jobId?: number;
  clientId: number;
  percentComplete: number;
  name: string;

  subtitle?: string;
  status: BGProcessStatus;
  link?: BGProcessLink;

  warnings: string[] | null;
  errors: string[] | null;
  startTime: number;
  endTime: number | null;

  type?: ProcessType;
}

type BGProcessError = Error & BGProcess;

interface RunningBGProcess extends BGProcess {
  success: () => void;
  fail: (e: Error) => void;
  warn: (warnings: string[]) => void;
  kill: () => void;
  setLink: (link: BGProcessLink) => void;
  setSubtitle: (subtitle: string) => void;
  setJobId: (jobId: number) => void;
  progress: (percentComplete: number) => void;
  setTitle: (title: string) => void;
}

enum ProcessType {
  REMOTE = 'remote',
  LOCAL = 'local',
  PERSISTENT_LOCAL = 'persistent_local',
}

type StartUiProcessParams<T> = {
  processName: string;
  processFunc: (bgProcess: RunningBGProcess) => Promise<T>;
  type?: ProcessType;
  id?: string;
  starDate?: DateTime;
};

export {
  BGProcess,
  BGProcessStatus,
  BGProcessLink,
  RunningBGProcess,
  BGProcessLinkType,
  BGProcessError,
  ProcessType,
  StartUiProcessParams,
};
